export default __webpack_public_path__ + "static/media/searchanimation.24dec44a.gif";